// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MLrPbZ_0BHDXy3fH5H_L{padding:0 50px;overflow-y:auto;overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/numbers/layout/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".container {\n  padding: 0 50px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MLrPbZ_0BHDXy3fH5H_L`
};
export default ___CSS_LOADER_EXPORT___;
